import React, { Component } from 'react';

class PolicyShip extends Component {
    render() {
        return (
            <section className="instruction__page mb-5 pb-5">
                <div className="container">
                    <div className="row pt-5 mb-3">
                        <div className="col-12">
                            <h2>Chính sách vận chuyển</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="content-page">
                                <p>Với mong muốn phục vụ khách hàng, lấy sự hài lòng của khách hàng làm mục đích để hướng đến. 
                                    <span style={{fontSize: "16px"}}><strong>ENDA&nbsp;</strong></span>
                                    <span style={{fontSize: "1px"}}><strong>KISUHI MIỄN PHÍ VẬN CHUYỂN TOÀN QUỐC</strong>
                                    </span>.</p><p>Thời gian giao hàng: trong vòng 5&nbsp;ngày tùy thuộc vào địa chỉ của khách hàng.</p>
                                    <p>Trong trường hợp phát sinh chậm trễ, Kisuhi sẽ cố gắng thông báo với quý khách về sự chậm trễ, quý khách có quyền từ chối nhận hàng.</p><p><strong>Mọi thắc mắc, quý khách hàng vui lòng liên hệ</strong><br />Hotline&nbsp; &nbsp;: 0888 37 29 29; 0942 37 22 29<br />Website&nbsp; : <a href="https://enda.vn/">enda.vn</a><br />Email&nbsp; &nbsp; &nbsp;: info@enda.vn<br />Facebook:&nbsp;<a href="https://www.facebook.com/Kisuhi/">facebook.com/Kisuhi</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default PolicyShip;
